export default __webpack_public_path__ + "static/media/tl.f7f09986.svg";